import { useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, { usePrepareGraphQLVariables } from "../../../../CommonFunction/CustomUseFormSubmission";
import { nextBillNo } from "../../../../Utils/AllPagesQuriesAndMutations";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
// import { data } from "./InvoiveNumber.config";

const InvoiceNumberConfiguration = ({
  show,
  voucherNumberConfig,
  TypeOfPortal,
  submitType,

  formRef,
  FormData,
  setFormData,
  Form_Key,
  SetBillNumber,
  setOpenBookCodeSet,
}) => {
  console.log(show, "show");
  const [isFirstLoad, setFirstLoad] = useState(false);
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const unique_key = "Inovice_COnfiguration";

  //Q & M

  const [GetNextBillNo] = useLazyQuery(nextBillNo, {
    fetchPolicy: "network-only",
  });

  const SalesInvoiceTypeLoadingState = false;


  useEffect(() => {
    updateValueForm(formRef, FormData);
    pushModal(unique_key);
  }, []);
  useEffect(() => {
    console.log(FormDataFromRedux?.MasterData, isFirstLoad, "isFirstLoad");
    if (FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series && isFirstLoad) {
      GetNextBillNo({
        variables: {
          id: FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series?._id,
        },
      }).then(({ data }) => {
        console.log(data, data?.getNextVoucherSeries?.Bill_No);
        updateSingleField(formRef, "Bill_No", data?.getNextVoucherSeries?.Bill_No);
      });
    } else if (FormDataFromRedux?.MasterData?.[Form_Key]?.Voucher_Series) {
      updateValueForm(formRef, FormData);
    }
  }, [FormData?.Voucher_Series, isFirstLoad]);


  const HanldeChangeonForm = (values) => {
    // console.log(values, "Formdata_without_redux1");
    setFormData((prev) => ({
      ...prev,
      ...values,
    }));
    // UpdateNextNumber()
  };





  const submit = async () => {
    SetBillNumber();
    Closeformfunction();
  };

  const Closeformfunction = useCallback(() => {
    setOpenBookCodeSet(false);
    settoggle(false);

    popModal(unique_key);
  }, []);



  return (
    <div>
      <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={"Select Voucher Series"}>
        <div className="horizontalcontainer">
          {voucherNumberConfig &&
            voucherNumberConfig.map((e) => {
              return (
                <div key={e.id} className="">
                  {/* <div className="sectionHeadings">{replaceUnderscore(e.name)}</div> */}
                  <div className="horizantalSection insidecontainer">
                    <FormInputSectionComponent
                      inputfields={e.fields}
                      Type={e.name}
                      onhandleFormikChange={(values) => {
                        console.log(values);
                        HanldeChangeonForm(values);
                      }}
                      validation_Schema={e?.Valid_schema}
                      // onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                      formkey={Form_Key}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                      isFirstLoad={isFirstLoad}
                    />
                  </div>
                </div>
              );
            })}
        </div>
        {/* <div className="horizontalcontainer">
                    <div className="horizantalSection">
                        {data &&
                            data.map((e) => {
                                return (
                                    <>
                                        <FormInputSectionComponent
                                            inputfields={e.fields}
                                            Type={e.name}
                                            fielddata={allFieldsData}
                                            TypeOfPortal={""}
                                            onhandleFormikChange={HanldeChangeonForm}
                                            formkey={Form_Key}
                                            formRef={formRef}
                                        />
                                    </>
                                );
                            })}



                    </div>
                </div> */}

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitType={submitType}
          submitform={() => submit()}
          SaveAndClose={() => submit()}
          Form_key={unique_key}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          loadingState={SalesInvoiceTypeLoadingState}
        />
      </Reactportal>
    </div>
  );
};

export default InvoiceNumberConfiguration;
